import React, { useState, useEffect } from 'react';

//import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { setProgress } from './Progreso';

const SeleccionHorarioOk = ({ planAcademico, resultadoInscripcion, planRigido }) => {
    useEffect(() => {
        setProgress(99, 'Inscripción finalizada');
    }, []);

    const handleSiguientesPasos = () => {
        window.location.reload();
    };

    let clasesInscritas = resultadoInscripcion?.ofertaacademica?.map(x => x.numclase);
    let inscritasNuevas = planAcademico?.ofertaacademica?.filter(x => clasesInscritas?.includes(x.numclase)) || [];
    let inscritasPrevias = planAcademico?.ofertainscrita || [];
    let todasLasInscritas = [...inscritasPrevias, ...inscritasNuevas];

    const obtenerLineasHorario = (h) => {
        if (h.displayCaption) return [h.displayCaption];

        const mapDias = { "L": "Lun", "M": "Mar", "MI": "Mie", "J": "Jue", "V": "Vie", "S": "Sab", "D": "Dom" };
        
        const formatearHora = (hora24) => {
            if (!hora24) return "00:00";
            let [horas, min] = hora24.split(':');
            let hrs = parseInt(horas, 10);
            hrs = hrs % 12 || 12;
            return `${hrs < 10 ? '0' + hrs : hrs}:${min}`;
        };

        const diasRaw = h.dia ? h.dia.split(',').map(d => d.trim()) : [];
        const inicio = formatearHora(h.horainicio);
        const fin = formatearHora(h.horafin);

        return diasRaw.map(d => `${mapDias[d] || d}: ${inicio} - ${fin}`);
    };

    return (<>
        <div className="container activacion">
            <Plantilla id="SeleccionHorarioOk" planInfo={planAcademico} />

            <div>
                {todasLasInscritas.map((materia, key) => {
                    const sesionNum = Number(materia.numsession);
                    const modulo = (sesionNum === 1 || sesionNum === 4) ? null : materia.numsessiondescr;

                    return (
                        <div className="materia-inscrita" key={key}>
                            <div>
                                <div className="title">{materia.descrclase}</div>
                                <div><i>{materia.notaclase}</i></div>
                                <div className="horario mt-1">
                                    {modulo && <>{modulo}< br /></>}
                                    {materia.esVirtual && (materia.virtual !== "N") ? 'Virtual' : (
                                        materia.horario && Array.isArray(materia.horario) && materia.horario.map((x, idx) => {
                                            const lineas = obtenerLineasHorario(x);
                                            return (
                                                <React.Fragment key={idx}>
                                                    {lineas.map((linea, index) => (
                                                        <div style={{ textWrapMode: "nowrap" }} key={`${idx}-${index}`}>
                                                            {linea}
                                                        </div>
                                                    ))}
                                                </React.Fragment>
                                            )
                                        })
                                    )}
                                </div>
                            </div>
                            <div>
                                <span className="material-symbols-outlined icon">check_circle</span>
                            </div>
                        </div>
                    );
                })}
            </div>

            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <Button variant="primary" onClick={handleSiguientesPasos}>Siguientes pasos</Button>
                </Col>
            </Row >
        </div>
    </>);
}

export default SeleccionHorarioOk;